import { Link } from '../../../components';
import HeaderImage1xPng from './assets/static/header.png';
import HeaderImage1xWebp from './assets/static/header.webp';
import HeaderImage1_5xPng from './assets/static/header@1_5x.png';
import HeaderImage1_5xWebp from './assets/static/header@1_5x.webp';
import HeaderImage2xPng from './assets/static/header@2x.png';
import HeaderImage2xWebp from './assets/static/header@2x.webp';
import { Container, LogoutButton } from './styles';

type PageHeaderProps = { canLogout: boolean };

const OnboardingPageHeader = ({ canLogout }: PageHeaderProps) => (
    <Container>
        <Link href="https://lokalise.com/">
            <picture>
                <source
                    srcSet={`${HeaderImage1xWebp} 1x, ${HeaderImage1_5xWebp} 1.5x, ${HeaderImage2xWebp} 2x, `}
                    type="image/webp"
                />
                <source
                    srcSet={`${HeaderImage1xPng} 1x, ${HeaderImage1_5xPng} 1.5x, ${HeaderImage2xPng} 2x, `}
                    type="image/png"
                />
                <img src={HeaderImage1xPng} width="102" height="22" alt="Lokalise" />
            </picture>
        </Link>

        {canLogout && (
            <LogoutButton href="/login?action=logout" aria-label="Logout">
                Log out
            </LogoutButton>
        )}
    </Container>
);

export default OnboardingPageHeader;
